module.exports = __webpack_public_path__ + "static/img/contact_logo7.ca649c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/contact_logo7.png
// module id = H2dM
// module chunks = 1